import { render, staticRenderFns } from "./pogs-submissions__cases--closed.vue?vue&type=template&id=071eb60e&"
import script from "./pogs-submissions__cases--closed.vue?vue&type=script&lang=js&"
export * from "./pogs-submissions__cases--closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports